import { isBrowser, postMessageHelper, ROUTES } from 'Utils';
import * as analytics from 'Utils/analytics';
import ProgressBar from 'Components/ProgressBar';

/**
 * HOC that will redirect to login page if user is not already logged in
 *
 * @param WrappedComponent
 */

const withLogin = (WrappedComponent) => (props) => {
  const isUserLoggedIn = () => {
    if (props.uim.isLoggedIn?.()) {
      analytics.trackUser(props.uim.getAuthenticatedUser());
      return true;
    }
    return false;
  };

  const redirectToLoginPage = () => {
    if (isBrowser()) props.transitionTo(ROUTES.PAGE_HOME.url);
  };

  if (!props.isUimLoaded) return <ProgressBar />;

  if (!isUserLoggedIn()) {
    if (props.location.pathname === ROUTES.PAGE_LOGOUT.url) {
      postMessageHelper.send({
        type: postMessageHelper.types.LOGOUT_FAILURE,
        payload: 'User unable to logout.  User was not logged in',
      });
    }
    redirectToLoginPage();
    return <ProgressBar />;
  }

  return <WrappedComponent {...props} />;
};

export default withLogin;
